import {
  SideNavigationWrapper,
  HeaderRow,
  Text,
  LeftToggleButton,
  Divider,
  Section,
  Label,
  Icon,
  RowWithTooltip,
} from '../Navbar/SideBar';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../routing';

export enum CMS_SIDEBAR_PAGES {
  ASSESSMENT_TESTS = 'assessment-tests',
  PROJECTS = 'projects',
  MODULES = 'modules',
}

export default function CMSSideBar({
  onClose,
  currentPage,
}: {
  onClose: () => void;
  currentPage: CMS_SIDEBAR_PAGES;
}) {
  const history = useHistory();

  return (
    <SideNavigationWrapper>
      <HeaderRow>
        <Text style={{ fontWeight: 'bold' }}>Content Management System</Text>
        <LeftToggleButton onClick={onClose} />
      </HeaderRow>
      <Divider />
      <Section>
        <Label>Content</Label>
        <RowWithTooltip
          id="cms-assessment-tests"
          isActive={currentPage === CMS_SIDEBAR_PAGES.ASSESSMENT_TESTS}
          onClick={() =>
            history.push(ROUTES.ADMIN.CMS_ASSESSMENT_TESTS.getPath())
          }
        >
          <Text>Assessment Tests</Text>
          <Icon className="fa-solid fa-clipboard-check" />
        </RowWithTooltip>
        <RowWithTooltip
          id="cms-modules"
          isActive={currentPage === CMS_SIDEBAR_PAGES.MODULES}
          onClick={() => history.push(ROUTES.ADMIN.CMS_MODULES.getPath())}
        >
          <Text>Modules</Text>
          <Icon className="fa-solid fa-cube" />
        </RowWithTooltip>
        <RowWithTooltip
          id="cms-projects"
          isActive={currentPage === CMS_SIDEBAR_PAGES.PROJECTS}
          onClick={() => history.push(ROUTES.ADMIN.CMS_PROJECTS.getPath())}
        >
          <Text>Projects</Text>
          <Icon className="fa-solid fa-diagram-project" />
        </RowWithTooltip>
      </Section>
    </SideNavigationWrapper>
  );
}
